import type { AutocompleteProps, TextFieldProps } from '@mui/material';
import { useMemo } from 'react';
import CheckboxAutocomplete from 'components/common/CheckboxAutocomplete';
import type { OptionValue } from 'components/common/CheckboxAutocomplete';

interface GoogleDomainAutocompleteProps
  extends Omit<AutocompleteProps<string, true, boolean, false>, 'value' | 'onChange' | 'options' | 'renderInput'> {
  value?: string[];
  onChange: (value: string[]) => void;
  InputProps?: TextFieldProps;
  allowedDomains: string[];
}

const GoogleDomainAutocomplete = ({
  InputProps,
  value,
  onChange,
  allowedDomains,
  ...props
}: GoogleDomainAutocompleteProps) => {
  const options = useMemo(
    () => allowedDomains.map((domain) => ({ label: domain, value: domain })),
    [allowedDomains]
  );

  return (
    <CheckboxAutocomplete
      {...props}
      value={value}
      onChange={onChange as (value: OptionValue[]) => void}
      InputProps={InputProps}
      id="google-domain-autocomplete"
      options={options}
    />
  );
};

export default GoogleDomainAutocomplete;
